import { Component, OnInit } from '@angular/core';
import {NvRewardsComponent} from "../nv-rewards/nv-rewards.component";
import {WatchService} from "../../services/watch.service";
import {CollectionService} from "../../services/collection.service";
import {FactoryService} from "../../services/factory.service";

@Component({
  selector: 'nv-rewards-with-icons',
  templateUrl: './nv-rewards-with-icons.component.html',
  styles: []
})
export class NvRewardsWithIconsComponent extends NvRewardsComponent{
  onAddClick() {
    this.factoryService.addRewardIconTo(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-rewards-with-icons/nv-rewards-with-icons.component.ts